import { AchievementsEducationLevel } from 'main/gql/globalTypes'
import {
  SchoolPage_school_director_achievements,
  SchoolPage_school_director_achievements_otherEducationItems,
  SchoolPage_school_director_achievements_specialCertificationItems,
} from '../gql'

export function hasAchievements(achievements: SchoolPage_school_director_achievements) {
  const {
    educationLevel,
    infantToddlerExperience,
    otherEducationItems,
    preschoolExperience,
    schoolExperience,
    specialCertificationItems,
  } = achievements

  return (
    educationLevel ||
    infantToddlerExperience ||
    preschoolExperience ||
    schoolExperience ||
    (otherEducationItems && filterOtherEducationItems(otherEducationItems).length) ||
    (specialCertificationItems && filterSpecialCertificationItems(specialCertificationItems).length)
  )
}

export function filterOtherEducationItems(
  items: SchoolPage_school_director_achievements_otherEducationItems[],
) {
  return items
    .filter(item => item.level)
    .map(item => ({
      level: item.level as AchievementsEducationLevel,
      name: item.name,
    }))
}

export function filterSpecialCertificationItems(
  items: SchoolPage_school_director_achievements_specialCertificationItems[],
) {
  return items
    .filter(item => item.name)
    .map(item => ({
      name: item.name as string,
    }))
}
